import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {Retailer, StoreDirectoryListing} from "../../model/Store";
import {StoreService} from "../../services/StoreService";
import {AuthService} from "../../services/AuthService";
import {StoreDashboardPage} from "../store-dashboard/store-dashboard";


export class MyRetailer extends Retailer {

  uiShouldBeHidden: boolean;
  uiStoreIds: number[] = [];

  from(r: Retailer): MyRetailer {
    this.code = r.code;
    this.id = r.id;
    this.name = r.name;
    return this;
  }

  addOneStore(id: number) {
    this.uiStoreIds.push(id);
  }
}

@IonicPage()
@Component({
  selector: 'page-store-directory',
  templateUrl: 'store-directory.html',
})
export class StoreDirectoryPage {

  uiloading: boolean;
  uiFilterVisible: boolean;

  stores: StoreDirectoryListing[];

  searchXp: string;

  private uiRetailers: MyRetailer[];

  /**
   * search / filter selection
   */
  uiSearchRetailerString: string;
  uiSelectedRetailer: Retailer;

  uiAdministrativeAreas: string;

  uiNbOfVisibleStores: number;

  constructor(public navCtrl: NavController, public navParams: NavParams, public storeService: StoreService, public authService: AuthService) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad StoreDirectoryPage');
  }

  ionViewDidEnter() {

    this.uiNbOfVisibleStores = 0;

    this.storeService.loadRetailers().then(retailers => {
      this.uiRetailers = [];
      const retailersById: MyRetailer[] = [];

      // -- process retailers to display in filtering
      retailers.forEach(r => {
        let rr = new MyRetailer().from(r);
        retailersById[r.id] = rr;
        this.uiRetailers.push(rr);
      });
      this.uiRetailers.sort((a, b) => a.name.toUpperCase().localeCompare(b.name.toUpperCase()));


      this.storeService.loadStoreDirectory().then((storeDirectory) => {
        this.stores = storeDirectory.stores;

        for (let i = 0; i < this.stores.length; i++) {

          let ret = retailersById[this.stores[i].retailer.id];
          if (ret != null) {
            ret.addOneStore(this.stores[i].id);
          }

          // -- we don't want to display too many stores
          if (i > 500) {
            this.stores[i].uiShouldBeHidden = true;
          }

        }

        this.uiloading = false;
      }).catch(err => {
        console.log('Could not load Stores - Api issue ?')
        console.log(err);
      });
    });
  }

  searchXpCallback($event: UIEvent) {
    this.filterStoresOnPage();
  }

  private filterStoresOnPage() {
    this.uiloading = true;

    //reset
    this.stores.forEach(s => s.uiShouldBeHidden = false);

    if (this.searchXp != null && this.searchXp.length > 1) {

      const rxp = new RegExp(this.searchXp, 'i');
      for (let itm of this.stores) {

        if (itm.uiShouldBeHidden) continue;

        let hideMe = this.searchXp != null && this.searchXp.length > 0;

        if (hideMe && itm.name.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.storeAliasClientCode != null && itm.storeAliasClientCode.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.storeAliasResourcePool != null && itm.storeAliasResourcePool.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.address != null && itm.address.city != null && itm.address.city.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.address != null && itm.address.line1 != null && itm.address.line1.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.address != null && itm.address.line2 != null && itm.address.line2.search(rxp) >= 0)
          hideMe = false;


        if (hideMe && itm.address != null && itm.address.zipCode != null && itm.address.zipCode.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.address != null && itm.address.administrativeArea != null && itm.address.administrativeArea.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.address != null) {
          if (itm.address.administrativeArea != null && itm.address.zipCode != null) {
            let cp = itm.address.administrativeArea + itm.address.zipCode;
            if (cp.search(rxp) >= 0)
              hideMe = false;
          }
        }

        if (hideMe && itm.retailer != null && itm.retailer.code != null && itm.retailer.code.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.retailer != null && itm.retailer.name != null && itm.retailer.name.search(rxp) >= 0)
          hideMe = false;

        itm.uiShouldBeHidden = hideMe;
      }
    }

    if (this.uiSelectedRetailer != null) {
      this.stores.forEach(st => {
        if (!st.uiShouldBeHidden && st.retailer.id != this.uiSelectedRetailer.id)
          st.uiShouldBeHidden = true;
      })
    }

    // -- search per admin areas
    if (this.uiAdministrativeAreas != null && this.uiAdministrativeAreas.length > 0) {
      let areas: string[] = this.uiAdministrativeAreas.split(/[ ,]+/);

      console.log("areast")
      console.log(areas);
      this.stores.forEach(st => {
        if (!st.uiShouldBeHidden) {
          let atLeastOne = false;

          for (let a of areas) {
            if (st.address != null && st.address.administrativeArea == a) {
              atLeastOne = true;
              break;
            }
          }

          if (!atLeastOne)
            st.uiShouldBeHidden = true;
        }
      })

    }


    //compute number of filtered stores, to be shown to the user for information
    this.uiNbOfVisibleStores = this.stores.filter(s => !s.uiShouldBeHidden).length;

    // display is slow if we have many, many stores... let's keep only a decent number
    if (this.uiNbOfVisibleStores > 500) {
      let i = 0;
      for (let st of this.stores) {

        if (i > 500) {
          st.uiShouldBeHidden = true;
        } else if (!st.uiShouldBeHidden) {
          i++;
        }
      }
    }

    this.uiloading = false;
  }

  onSelectStore(i
                  :
                  number
  ) {
    this.navCtrl.push(StoreDashboardPage, {'storeId': this.stores[i].id})
  }

  retailerSelected(ret
                     :
                     Retailer
  ) {
    this.uiSearchRetailerString = ret.name;
    this.uiSelectedRetailer = ret;
    this.filterStoresOnPage();
  }

  searchRetailerXpCallback($event
                             :
                             UIEvent
  ) {

    this.uiSelectedRetailer = null;

    if (this.uiSearchRetailerString == null || this.uiSearchRetailerString.length <= 1) {
      this.uiRetailers.forEach(r => r.uiShouldBeHidden = false);
    } else {
      let str = this.uiSearchRetailerString.toUpperCase();
      this.uiRetailers.forEach(r => r.uiShouldBeHidden = r.name.toUpperCase().search(str) < 0);
    }
  }

  searcAreasXpCallBack($event
                         :
                         UIEvent
  ) {
    this.filterStoresOnPage();
  }

  toggleFilterVisibility() {
    this.uiFilterVisible = !this.uiFilterVisible;
  }
}



// WEBPACK FOOTER //
// ./src/pages/store-directory/store-directory.ts